import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommentsService } from '../../services/comments.service';
import { Comment } from '../../types/comment';
import { first, take, takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { SharedService } from '@ml/shared/services/shared.service';
import { User } from '@ml/core/types/classes/user.class';
import { SidenavService, UserService } from '@ml/core/services';

@Component({
  selector: 'ml-comments-sidenav',
  template: `
    <div fxLayout="column">
      <h3 class="mat-title" fxLayout="row" fxLayoutAlign="space-between center">
        <span *ngIf="title; else genericTitle">{{ title }}</span>
        <ng-template #genericTitle>{{
          'add comment' | translate | sentancecase
        }}</ng-template>
        <button mat-icon-button (click)="onClose()">
          <mat-icon svgIcon="close">clear</mat-icon>
        </button>
      </h3>
      <ml-comment-form #formComponent (post)="onAdd($event)"></ml-comment-form>
      <ml-comments-list
        [comments]="comments$ | async"
        [loadingMore]="loadingMore$ | async"
        [loading]="loading$ | async"
        [next]="next$ | async"
        [currentUser]="currentUser$ | async"
        (loadMore)="onLoadMore()"
        (deleteComment)="onDelete($event)"
      ></ml-comments-list>
    </div>
  `,
  styleUrls: ['./comments.component.scss']
})
export class CommentsComponent implements OnInit, OnDestroy {
  @ViewChild('formComponent', { static: true }) formComponent;
  currentUser$: Observable<User>;
  title: string;

  comments$: Observable<Comment[]>;
  loading$: Observable<boolean>;
  loadingMore$: Observable<boolean>;
  next$: Observable<boolean>;

  ngUnsubscribe = new Subject();

  constructor(
    private commentsService: CommentsService,
    private sharedService: SharedService,
    private userService: UserService,
    private sidenavService: SidenavService
  ) {}

  ngOnInit() {
    this.commentsService.refresh();
    this.currentUser$ = this.userService.get();
    this.comments$ = this.commentsService.subscribeValues$();
    this.loadingMore$ = this.commentsService.loading$;
    this.loading$ = this.commentsService.loading$.pipe(take(2));
    this.next$ = this.commentsService.hasNext$;

    this.commentsService.title
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((title: string) => (this.title = title));

    if (this.formComponent.form) {
      this.formComponent.form.reset();
    }
  }

  onLoadMore() {
    this.commentsService.loadNextPage();
  }

  onAdd(comment: Comment) {
    this.commentsService.add(comment).subscribe();
  }

  onDelete(comment: Comment) {
    this.commentsService
      .delete(comment.id)
      .subscribe(() =>
        this.sharedService.showMessage('comment deleted successfully', 500)
      );
  }

  onClose() {
    this.sidenavService.close();
  }

  ngOnDestroy(): void {
    this.commentsService.unsubscribeManageComments();
    this.ngUnsubscribe.complete();
    this.ngUnsubscribe.next();
  }
}
